/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IUserActionModalControllerScope extends IBaseModalControllerScope {
        userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto;
        model: models.UserActionModalModel;
        fileUploadModel: models.FileUploadModel;
        canSave(): boolean;
        getValidationMessages(): string[];
        documentUpdated(model: models.FileUploadModel): void;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        userActionService: services.UserActionService;
        userActionInfoUniqueId: string;
        resetEffectiveDate: () => void;
    }

    export class UserActionModalController extends BaseModalController {
        scope: IUserActionModalControllerScope;

        constructor(
            $scope: IUserActionModalControllerScope,
            userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto,
            model: models.UserActionModalModel,
            process: Wars.Domain.Model.Dtos.ProcessDto,
            userActionInfoUniqueId: string,
            documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration,
            systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration,
            userActionService: services.UserActionService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.userActionDto = userActionDto;
            this.scope.model = model;
            this.scope.process = process;
            this.scope.userActionInfoUniqueId = userActionInfoUniqueId;
            this.scope.documentConfiguration = documentConfiguration;
            this.scope.systemDocumentConfiguration = systemDocumentConfiguration;
            this.scope.userActionService = userActionService;

            this.scope.canSave = () => this.getValidationMessages(this.scope).length === 0;
            this.scope.getValidationMessages = () => this.getValidationMessages(this.scope);
            this.scope.documentUpdated = (model: models.FileUploadModel) => this.documentUpdated(model);
            this.scope.resetEffectiveDate = () => {
                this.scope.model.effectiveDate = undefined;
            };

            //Randy - transient user action data preservation for validation error
            var transientUserActionDto = userActionService.getTransientUserActionData(userActionDto.id);
            if (transientUserActionDto != null) {
                this.scope.model.processActionWorkflowBlockId = transientUserActionDto.processActionWorkflowBlockId;
                this.scope.model.effectiveDate = transientUserActionDto.effectiveDate;
                this.scope.model.comment = transientUserActionDto.comment;
                this.scope.model.docIds = transientUserActionDto.docIds;
                this.scope.model.showEffectiveDate = transientUserActionDto.effectiveDate != null && transientUserActionDto.effectiveDate != undefined;
                if (transientUserActionDto.documents != null) {
                    for (var i = 0; i < transientUserActionDto.documents.length; i++) {
                        this.scope.process.documents.push(transientUserActionDto.documents[i]);
                    }    
                }
            }
            //Randy - end transient user action data preservation for validation error
        }

        private getValidationMessages(scope: IUserActionModalControllerScope) : string[] {
            var results = [];
            if (scope.userActionDto.commentRequired && !scope.model.comment) results.push("A comment is required.");
            if (scope.userActionDto.attachmentRequired && scope.model.docIds.length === 0) results.push("An attachment is required.");
            return results;
        }

        private documentUpdated(model: models.FileUploadModel): void {
            this.scope.model.docIds = Enumerable.from(model.documents).select(i => i.id).toArray();
            //Randy - transient user action data preservation for validation error
            this.scope.userActionService.updateDocuments(model.documents);
            //Randy - end transient user action data preservation for validation error
        }
    }
}

warsApp.registerController('UserActionModalController', ["$scope", "userActionDto", "model", "process", "userActionInfoUniqueId", "documentConfiguration", "systemDocumentConfiguration", "userActionService", "close"]);